import styles from "./UnaffordableAlertModal.module.scss";
import { imagePrefix } from "../../../utils/helperServices";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import {
  Modal,
  CustomContainer,
} from "../../atoms/DependencyHelper";
import IconsComponent from "../../atoms/iconsComponent/IconsComponent";

const UnaffordableAlertModal = ({
  displayData,
  showModal,
  creditFilters,
  toggleModal,
  onClickHandlerPrimary,
}) => {

  const scrollToTop = () => {
    // scrolling the window up when closing the modal
    if (showModal) window.scrollTo(0, 0);
  };
  const toggleUpgradeModal = () => {
    scrollToTop();
    toggleModal();
  };

  const primaryButtonClick = (url) => {
    scrollToTop();
    onClickHandlerPrimary(url);
  };

  return (
    showModal && (
      <Modal
        show={showModal}
        dialogClassName={`${styles["upgrade-modal1"]}`}
        onHide={toggleUpgradeModal}
        centered
        backdrop="static"
      >
        <Modal.Header className={styles["modal-header"]}>
          <CustomContainer onClick={toggleUpgradeModal}>
            <IconsComponent type="closeBlack" />
          </CustomContainer>
        </Modal.Header>
        <Modal.Body className={styles["modal-body"]}>
          <div className={styles["upgradeComponent"]}>
            <div className={styles["otp-tick-img"]}>
              <img
                src={`${imagePrefix}/assets/images/icon-sucess.svg`}
                width={40}
                height={40}
              />
            </div>
            {displayData?.resultTitle && (
              <div className={styles.title}>{displayData?.resultTitle}</div>
            )}

            {displayData?.resultHTML && (
              <div
                className={`${styles.description}`}
                dangerouslySetInnerHTML={{
                  __html: displayData?.resultHTML,
                }}
              />
            )}

            <CTAButton
              variant={displayData?.primaryButtonStyle}
              className={`${styles[displayData?.primaryButtonClass]}`}
              handleClick={() => primaryButtonClick(displayData?.primaryCTAURL)}
            >
              {displayData?.primaryCTAText}
            </CTAButton>
          </div>
        </Modal.Body>
      </Modal>
    )
  );
};

UnaffordableAlertModal.propTypes = {};

export default UnaffordableAlertModal;
